import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import AdminCreatePage from "./AdminCreatePage";
import AdminGamePage from "./AdminGamePage";
import UserRegisterPage from "./UserRegisterPage";
import UserGamePage from "./UserGamePage";
import Layout from "../components/Layout";
import ErrorPage from "./ErrorPage";

const router = createBrowserRouter([
  {
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <div>Please ask for the game link</div>,
      },
      {
        path: "/admin/game",
        element: <AdminCreatePage />,
      },
      {
        path: "/admin/game/:gameId",
        element: <AdminGamePage />,
      },
      {
        path: "/game/:gameId/register",
        element: <UserRegisterPage />,
      },
      {
        path: "/game/:gameId/player/:playerId",
        element: <UserGamePage />,
      },
    ],
  },
]);

const Pages: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default Pages;
